module.exports = {raw:"8.0.4"};



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 16
// module chunks = 0